import Swiper from 'swiper';
import { Controller, Navigation, Thumbs} from 'swiper/modules';

export const Slider = () => {
    const swiperElements = [];

    const isInitialized = (element) => {
        if (swiperElements.length === 0) {
            return false;
        }

        if (swiperElements.includes(element)) {
            return true;
        }

        return element.classList.contains('swiper-initialized') || element.classList.contains('swiper-init-loading')
    };

    const getNavigation = (element, {
        nextSelector = '.btn-swiper-next',
        prevSelector = '.btn-swiper-prev'
    }) => {
        if (!(element instanceof HTMLElement)) {
            element = document.querySelector(element);
        }

        if (!element) {
            return null;
        }

        const nextElement = element.parentElement.querySelector(nextSelector);
        const prevElement = element.parentElement.querySelector(prevSelector);

        if (!nextElement || !prevElement) {
            return null;
        }

        return {
            nextEl: nextElement,
            prevEl: prevElement,
        };
    };

    const preventNavigation = (cleanUp = false) => {
        return {
            preventClicksPropagation: true,
            preventClicks: true,
            on: {
                init(swiper) {
                    if (cleanUp) {
                        destroyNavigation(swiper);
                    }
                },
            }
        }
    }

    const destroyNavigation = (swiper) => {
        if (!!swiper.navigation) {
            swiper.navigation.destroy();
        }
    };

    const findActiveThumb = (thumbs, slider) => {
        const thumbLiElements = thumbs.querySelectorAll("li.thumb");
        thumbLiElements.forEach((thumb, index) => {
            thumb.classList.remove('active');
            if (index === slider.activeIndex) {
                thumb.classList.add('active');
            }
        });
    };

    const init = ({
                      mainSliderSelector,
                      thumbsSliderSelector, 
                      cleanup = false
    }) => {
        let mainSliderWrapper;

        // Check if the mainSliderSelector is a html-element or a classname
        // => fill in the mainSliderWrapper variable depending on the outcome
        if (typeof mainSliderSelector === 'string') {
            mainSliderWrapper = document.querySelector(mainSliderSelector + ' .swiper-wrapper');
        } else {
            mainSliderWrapper = mainSliderSelector.querySelector('.swiper-wrapper');
        }

        // When there is no wrapper element the function may not be executed
        if (!mainSliderWrapper) {
            return null;
        }

        // When the slider is already initialized do not execute further
        if (isInitialized(mainSliderSelector)) return null;

        // Push the element to the swiperElements array
        swiperElements.push(mainSliderSelector);

        // Add swiper class to the mainSlider element
        mainSliderSelector.classList.add('swiper-init-loading');

        const customSliderOptions = {
            modules: [Navigation, Thumbs, Controller],
            slidesPerView: 1,
            spaceBetween: 10,
        };

        return new Swiper(mainSliderSelector, {
            ...customSliderOptions,
            navigation: getNavigation(mainSliderSelector, {
                nextSelector: '.btn-swiper-next',
                prevSelector: '.btn-swiper-prev'
            }),
            thumbs: thumbsSliderSelector,
            ...preventNavigation(cleanup),
            on: {
                init: function (swiper) {
                    thumbsSliderSelector.querySelectorAll('li.thumb').forEach((thumb, index) => {
                        thumb.addEventListener('click', function (e) {
                            swiper.slideTo(index);
                            findActiveThumb(thumbsSliderSelector, swiper);
                        });
                    });

                    findActiveThumb(thumbsSliderSelector, swiper);
                },
                activeIndexChange: function (swiper) {
                    findActiveThumb(thumbsSliderSelector, swiper);
                },
            },
        });
    };

    return {
        init
    }
};